import { gravComponentSchema } from '../deep-form-grav';
import { defaults } from '@/components/ui/HorizontalNavigation';
import type { HorizontalNavigationProps } from '@/components/ui/HorizontalNavigation';

type WithSlots = HorizontalNavigationProps & {
  '#default': string;
};

const { s, l, bl, toExport } = gravComponentSchema<WithSlots>({
  title: 'HorizontalNavigation',
  link: 'https://www.notion.so/mlmsoft/Horizontal-Navigation',
  text: text(),
}, defaults);

export default toExport;



// Button appearance
s.add('btnVariant').input('dictionary').data([
  {title: 'Text', value: 'text'},
  {title: 'Flat', value: 'flat'},
  {title: 'Outlined', value: 'outlined'},
  {title: 'Plain', value: 'plain'},
  {title: 'Tonal', value: 'tonal'},
  {title: 'Elevated', value: 'elevated'},
]).title('Button variant').col(4);

s.add('btnSize').input('dictionary').data([
  {title: 'X-Small', value: 'x-small'},
  {title: 'Small', value: 'small'},
  {title: 'Default', value: 'default'},
  {title: 'Large', value: 'large'},
  {title: 'X-Large', value: 'x-large'},
]).title('Button size').col(4);

s.add('btnRounded').input('vtext')
  .title('Rounded').desc('true | false | number | radius string').col(4);

s.add('btnColor').input('vtext')
  .title('Button color').col(4);

s.add('btnDensity').input('dictionary').data([
  {title: 'Default', value: 'default'},
  {title: 'Comfortable', value: 'comfortable'},
  {title: 'Compact', value: 'compact'},
]).title('Density').col(4);

s.add('btnClass').input('vtext')
  .title('Button class').col(4);

s.add('showIcons').input('boolean')
  .title('Show icons').col(4);

s.add('dropdownIcon').input('vtext')
  .title('Dropdown icon').col(4);

// Wrapper & layout
s.add('wrapper').input('dictionary').data([
  {title: 'Toolbar', value: 'toolbar'},
  {title: 'None', value: 'none'},
]).title('Wrapper').col(4);

s.add('color').input('vtext')
  .title('Toolbar color').col(4);

s.add('navClass').input('vtext')
  .title('Nav container class').col(4);

s.add('gapClass').input('vtext')
  .title('Gap class').col(4);

// Dropdown card / children styles
s.add('cardMaxWidth').input('vtext')
  .title('Card max width').desc('number or CSS width').col(4);

s.add('cardClass').input('vtext')
  .title('Card class').col(4);

s.add('cardContentClass').input('vtext')
  .title('Card content class').col(4);

s.add('listItemClass').input('vtext')
  .title('List item class').col(4);

s.add('iconBgColor').input('vtext')
  .title('Avatar color').col(4);

s.add('iconBgHoverColor').input('vtext')
  .title('Avatar hover color').col(4);

s.add('iconColor').input('vtext')
  .title('Icon color').col(4);

s.add('iconHoverColor').input('vtext')
  .title('Icon hover color').col(4);

s.add('iconClass').input('vtext')
  .title('Icon class').col(4);

s.add('iconHoverClass').input('vtext')
  .title('Icon hover class').col(4);


// Slot
s.add('#default').input('vtextarea').props({ clearable: true })
  .flag('isSlot').flag('isText')
  .title('Default slot').col(12);

function text() {
  return `HorizontalNavigation renders a one-row navigation made of buttons, visually aligned with DashboardDrawerTop`;
}
